import React from "react";
import styled from "styled-components";

const isBlack = key => key.includes("b") || key.includes("#");

const Key = props => (
  <div {...props} onMouseDown={() => props.onMouseDown(props.value)} />
);

export default styled(Key)`
  box-sizing: border-box;
  height: 100%;
  background: ${props => (props.active ? "#80e4d6" : "#f3f3f3")};
  border-radius: 3px;
  margin-left: ${props => (isBlack(props.value) ? 0 : 1)}px;
  width: ${props => (isBlack(props.value) ? 0 : 50)}px;
  cursor: pointer;

  ::before {
    content: " ";
    box-sizing: border-box;
    display: ${props => (isBlack(props.value) ? "block" : "none")};
    height: 58%;
    width: 30px;
    background: ${props => (props.active ? "#24564e" : "#444")};
    position: relative;
    left: -15px;
    border-radius: 3px;
    border-left: 6px solid ${props => (props.active ? "#47726c" : "#666")};
    border-right: 6px solid ${props => (props.active ? "#053f37" : "#333")};
    border-bottom: 12px solid ${props => (props.active ? "#08362f" : "#222")};
  }

  span {
    display: ${props => (isBlack(props.value) ? "none" : "block")};
    position: relative;
    top: 85%;
    text-align: center;
  }
`;
